<template>
	<div class="ui-switcher">
		<input
			v-model="isModalChecked"
			type="checkbox"
			:id="name"
			class="ui-switcher__input"
			:name="name"
			:disabled="isDisable"
		/>
		<label :for="name" class="ui-switcher__label"></label>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

/**
 * Стилизованный checkbox
 * Rounded switch (Закругленный переключатель)
 */
@Options({
	props: {
		name: { type: String, default: "" },
		isChecked: { type: Boolean, default: false },
		isArrayItems: { type: Boolean, default: false },
		itemId: { type: Number, default: 0 },
		isDisable: { type: Boolean, default: false },
	},
})
export default class UiSwitcher extends Vue {
	public name: string;
	public isChecked: boolean;
	public isArrayItems: boolean;
	public itemId: number;

	public isLocalChecked = false;

	public get isModalChecked() {
		return this.isLocalChecked || this.isChecked;
	}

	public set isModalChecked(value: boolean) {
		if (this.isArrayItems) {
			this.$emit("checked-item", {
				id: this.itemId,
				name: this.name,
				isActive: value,
			});
		} else {
			this.$emit(this.name, value);
		}

		this.isLocalChecked = value;
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ui-switcher {
	display: flex;

	&__input {
		height: 0;
		width: 0;
		visibility: hidden;
		cursor: pointer;
	}

	&__label {
		position: relative;
		margin-left: -10px;
		text-indent: -100px;
		width: 28px;
		height: 16px;
		background: rgb(188, 192, 207);
		display: block;
		border-radius: 100px;
		cursor: pointer;
	}

	&__label:after {
		content: "";
		position: absolute;
		top: 2px;
		left: 2px;
		width: 12px;
		height: 12px;
		background: #ffffff;
		border-radius: 90px;
		transition: 0.2s;
	}

	&__input:checked + &__label {
		background: var(--theme-color);
	}

	&__label:active:after {
		width: 15px;
	}

	&__input:checked + &__label:after {
		left: calc(100% - 2px);
		transform: translateX(-100%);
	}
}
</style>
